import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Seal from '../../../../assets/images/Seal.png';
import Signature from '../../../../assets/images/Signature.png';
import { ImgWebp } from '../../../commons/ImgWeb';
import { numWord } from '../../../../utils';

interface DeviceProps {
  device: string;
  serialNumber: string;
  warranty: number;
  installed: string;
  rent: boolean;
}

export const Device: FC<DeviceProps> = ({ device, serialNumber, warranty, installed, rent }) => {
  const { t } = useTranslation();
  const months = ['accountSettings.months', 'accountSettings.month', 'accountSettings.someMonth'];

  return (
    <div className="device">
      {rent && (
        <div className="device__rent">
          <p className="device__rent__label">{t('accountSettings.brizRent')}</p>
        </div>
      )}
      <div className="device__header">
        <p className="device__header__label">{t('accountSettings.model')}</p>
        <p className="device__header__device-name">{device}</p>
      </div>
      <div className="device__info">
        <div className="device__info__serial-number device__info__item">
          <p className=" device__info__item__label">{t('accountSettings.serialNumber')}</p>
          <p className="device__info__serial-number__value device__info__item__value">{serialNumber}</p>
        </div>
        <div className="device__info__warranty device__info__item">
          <p className=" device__info__item__label">{t('accountSettings.warranty')}</p>
          <p className="device__info__warranty__value device__info__item__value">{`${warranty} ${t(
            numWord(warranty, months),
          )}`}</p>
        </div>
        <div className="device__info__installed device__info__item">
          <p className=" device__info__item__label">{t('accountSettings.installed')}</p>
          <p className="device__info__installed__value device__info__item__value">{installed}</p>
        </div>
      </div>
      <div className="device__images">
        <ImgWebp fallback={Seal} alt="seal" />
        <ImgWebp fallback={Signature} alt="signature" />
      </div>
    </div>
  );
};
